"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColorFromMoral = getColorFromMoral;
exports.getMalusFromMoral = getMalusFromMoral;
function getMalusFromMoral(moral) {
    if (moral < 20) {
        return 20;
    }
    else if (moral < 40) {
        return 15;
    }
    else if (moral < 60) {
        return 10;
    }
    else if (moral < 80) {
        return 5;
    }
    else {
        return 0;
    }
}
function getColorFromMoral(moral) {
    if (moral < 20) {
        return "#ff0000";
    }
    else if (moral < 40) {
        return "#ff7b00";
    }
    else if (moral < 60) {
        return "#ffcc00";
    }
    else if (moral < 80) {
        return "#ffff00";
    }
    else {
        return "#00FF00";
    }
}
